(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mg-collections-hub"]) return;
  try {
    
  (() => {
    const initialise = (scope) => {
      scope.querySelectorAll('[data-mg-collections]').forEach((root) => {
        if (root.dataset.mgchReady) return;
        root.dataset.mgchReady = 'true';
        const controls = root.querySelector('[data-mgch-filters]');
        const buttons = Array.from(root.querySelectorAll('[data-mgch-filter]'));
        const cards = Array.from(root.querySelectorAll('[data-mgch-card]'));
        const counter = root.querySelector('[data-mgch-count]');
        const empty = root.querySelector('[data-mgch-empty]');
        if (!controls || !counter || !empty) return;
        controls.hidden = false;
        controls.addEventListener('click', (event) => {
          const button = event.target.closest('[data-mgch-filter]');
          if (!button || !controls.contains(button)) return;
          const group = button.dataset.mgchFilter;
          let visible = 0;
          buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          cards.forEach((card) => {
            const groups = (card.dataset.group || '').split(',');
            card.hidden = group !== 'all' && !groups.includes(group);
            if (!card.hidden) visible += 1;
          });
          counter.textContent = `${visible} ${visible === 1 ? counter.dataset.one : counter.dataset.many}`;
          empty.hidden = visible > 0;
        });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document), { once: true });
    else initialise(document);
    document.addEventListener('shopify:section:load', (event) => initialise(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mr-golf-gift-finder-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-mg-gift-finder-page]';

    const initialise = (root) => {
      if (!root || root.dataset.mgInitialised === 'true') return;

      root.dataset.mgInitialised = 'true';

      const steps = Array.from(root.querySelectorAll('[data-step]'));
      const finderPanel = root.querySelector('[data-finder-panel]');
      const results = root.querySelector('[data-results]');
      const resultGrid = root.querySelector('[data-result-grid]');
      const catalog = Array.from(
        root.querySelectorAll('[data-catalog] .mg-gfp__product-card')
      );
      const nextButton = root.querySelector('[data-next]');
      const backButton = root.querySelector('[data-back]');
      const progressLabel = root.querySelector('[data-progress-label]');
      const progressQuestion = root.querySelector('[data-progress-question]');
      const progressBar = root.querySelector('[data-progress-bar]');
      const corporateResult = root.querySelector('[data-corporate-result]');

      const answers = {};
      let currentStep = 0;
      let isAdvancing = false;
      let advanceTimer = null;

      const questionNames = steps.map((step) => {
        const legend = step.querySelector('legend');
        return legend ? legend.textContent.trim() : '';
      });

      const budgetRanges = {
        under_50: {
          min: 0,
          max: 4999
        },
        '50_75': {
          min: 5000,
          max: 7500
        },
        '75_100': {
          min: 7501,
          max: 10000
        },
        '100_plus': {
          min: 10001,
          max: Number.POSITIVE_INFINITY
        }
      };

      const setSelected = (step, value) => {
        if (!step) return;

        const group = step.dataset.group;
        const options = Array.from(step.querySelectorAll('[data-answer]'));

        options.forEach((option) => {
          const selected = option.dataset.answer === value;
          option.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        answers[group] = value;

        if (nextButton) {
          nextButton.disabled = false;
        }
      };

      const updateNextButton = () => {
        if (!nextButton) return;

        const isFinalStep = currentStep === steps.length - 1;
        nextButton.innerHTML = '';
        nextButton.appendChild(
          document.createTextNode(
            isFinalStep ? 'See my recommendations' : 'Continue'
          )
        );

        if (!isFinalStep) {
          const icon = document.createElementNS(
            'http://www.w3.org/2000/svg',
            'svg'
          );

          icon.setAttribute('viewBox', '0 0 20 20');
          icon.setAttribute('aria-hidden', 'true');
          icon.innerHTML = '<path d="M4 10h11M11 6l4 4-4 4"/>';
          nextButton.appendChild(icon);
        }
      };

      const showStep = (index) => {
        currentStep = Math.max(0, Math.min(index, steps.length - 1));

        steps.forEach((step, stepIndex) => {
          step.hidden = stepIndex !== currentStep;
        });

        if (progressLabel) {
          progressLabel.textContent = `Step ${currentStep + 1} of ${steps.length}`;
        }

        if (progressQuestion) {
          progressQuestion.textContent = questionNames[currentStep];
        }

        if (progressBar) {
          progressBar.style.width = `${((currentStep + 1) / steps.length) * 100}%`;
        }

        if (backButton) {
          backButton.hidden = currentStep === 0;
        }

        updateNextButton();

        const activeGroup = steps[currentStep]?.dataset.group;

        if (nextButton) {
          nextButton.disabled = !answers[activeGroup];
        }
      };

      const getScore = (card) => {
        let score = Number(card.dataset.popularity || 0) * 0.6;

        const fit = card.dataset.fit;
        const categories = (card.dataset.categories || '')
          .split(',')
          .map((value) => value.trim())
          .filter(Boolean);
        const recipient = card.dataset.recipient;
        const premium = Number(card.dataset.premium || 0);
        const family = card.dataset.family || card.dataset.key;
        const knowledge = answers.knowledge;
        const preference = answers.preference;
        const occasion = answers.occasion;
        const selectedRecipient = answers.recipient;

        if (knowledge === 'know_both') {
          score += fit === 'required' ? 8 : fit === 'none' ? 4 : 1;
        } else if (fit === 'none') {
          score += 9;
        } else if (fit === 'voucher') {
          score += 4;
        }

        if (preference === 'unsure') {
          score += Number(card.dataset.popularity || 0) * 0.5;
        } else if (categories.includes(preference)) {
          score += 9;
        } else {
          score -= 2;
        }

        if (preference === 'complete') {
          score += premium * 0.8;
        }

        if (answers.budget === '100_plus') {
          score += premium;
        }

        if (selectedRecipient === 'woman' && recipient === 'women') {
          score += 7;
        }

        if (
          (selectedRecipient === 'dad' || selectedRecipient === 'man') &&
          recipient === 'men'
        ) {
          score += 6;
        }

        if (occasion === 'corporate' || selectedRecipient === 'client') {
          if (fit === 'none') score += 4;

          if (
            categories.includes('organisation') ||
            categories.includes('on_course')
          ) {
            score += 3;
          }

          if (fit === 'voucher') score -= 2;
        }

        if (occasion === 'wedding') {
          if (fit === 'none') score += 3;

          if (
            family === 'pouch_bag' ||
            family === 'scorecard_holder' ||
            family === 'ball_marker'
          ) {
            score += 3;
          }
        }

        if (occasion === 'retirement') {
          score += premium * 0.45;
        }

        if (
          occasion === 'fathers_day' &&
          (recipient === 'men' || recipient === 'all')
        ) {
          score += 2;
        }

        if (
          occasion === 'christmas' ||
          occasion === 'birthday' ||
          occasion === 'just_because'
        ) {
          score += Number(card.dataset.popularity || 0) * 0.25;
        }

        return score;
      };

      const buildReason = (card) => {
        const reasons = [];
        const fit = card.dataset.fit;
        const categories = (card.dataset.categories || '').split(',');
        const price = Number(card.dataset.price || 0);
        const range = budgetRanges[answers.budget] || budgetRanges['50_75'];

        if (fit === 'required' && answers.knowledge === 'know_both') {
          reasons.push(
            'You know the glove details, so a fitted personalised glove remains a confident option.'
          );
        }

        if (
          fit === 'none' &&
          (
            answers.knowledge === 'know_hand' ||
            answers.knowledge === 'no_size' ||
            answers.knowledge === 'prefer_no_size'
          )
        ) {
          reasons.push('No glove size or hand selection is required.');
        }

        if (fit === 'voucher') {
          reasons.push(
            'They can choose the correct glove fit and preferred colour themselves.'
          );
        }

        if (
          answers.preference !== 'unsure' &&
          categories.includes(answers.preference)
        ) {
          const preferenceCopy = {
            on_course: 'It matches your preference for something used on the course.',
            organisation: 'It suits golf organisation and storage.',
            travel: 'It suits golf trips and travel.',
            complete: 'It has the substance of a more premium gift.'
          };

          reasons.push(preferenceCopy[answers.preference]);
        }

        if (price >= range.min && price <= range.max) {
          reasons.push('It sits within your selected budget.');
        }

        if (answers.occasion === 'corporate' || answers.recipient === 'client') {
          reasons.push('It can also suit professional or event gifting.');
        }

        if (reasons.length === 0) {
          reasons.push('A versatile personalised option with broad gifting appeal.');
        }

        return reasons.slice(0, 2).join(' ');
      };

      const chooseRecommendations = () => {
        const range = budgetRanges[answers.budget] || budgetRanges['50_75'];
        const selectedRecipient = answers.recipient;
        const knowledge = answers.knowledge;

        /*
         * Eligibility rules run before scoring:
         * - the budget is strict;
         * - fitted gloves are excluded unless hand and size are known;
         * - gendered gloves are excluded when the selected recipient conflicts.
         */
        const eligibleCatalog = catalog.filter((card) => {
          const price = Number(card.dataset.price || 0);
          const fit = card.dataset.fit;
          const recipient = card.dataset.recipient;

          if (
            !Number.isFinite(price) ||
            price < range.min ||
            price > range.max
          ) {
            return false;
          }

          if (fit === 'required' && knowledge !== 'know_both') {
            return false;
          }

          if (selectedRecipient === 'woman' && recipient === 'men') {
            return false;
          }

          if (
            (selectedRecipient === 'dad' || selectedRecipient === 'man') &&
            recipient === 'women'
          ) {
            return false;
          }

          return true;
        });

        const scored = eligibleCatalog
          .map((card) => ({
            card,
            score: getScore(card)
          }))
          .sort((a, b) => {
            if (b.score !== a.score) return b.score - a.score;

            return (
              Number(b.card.dataset.popularity || 0) -
              Number(a.card.dataset.popularity || 0)
            );
          });

        if (scored.length === 0) return [];

        const chosen = [];

        const addUnique = (entry, label) => {
          if (!entry) return;

          const entryFamily =
            entry.card.dataset.family ||
            entry.card.dataset.key;

          const alreadyChosen = chosen.some((item) => {
            const chosenFamily =
              item.entry.card.dataset.family ||
              item.entry.card.dataset.key;

            return chosenFamily === entryFamily;
          });

          if (alreadyChosen) return;

          chosen.push({
            entry,
            label
          });
        };

        addUnique(scored[0], 'Best match');

        const safe = scored.find((entry) => {
          const fit = entry.card.dataset.fit;

          return (
            fit === 'none' ||
            fit === 'voucher'
          );
        });

        addUnique(safe, 'Safest choice');

        const premium = scored
          .filter((entry) => {
            const entryFamily =
              entry.card.dataset.family ||
              entry.card.dataset.key;

            return !chosen.some((item) => {
              const chosenFamily =
                item.entry.card.dataset.family ||
                item.entry.card.dataset.key;

              return chosenFamily === entryFamily;
            });
          })
          .sort((a, b) => {
            const premiumDifference =
              Number(b.card.dataset.premium || 0) -
              Number(a.card.dataset.premium || 0);

            return premiumDifference || b.score - a.score;
          })[0];

        addUnique(premium, 'Premium option');

        scored.forEach((entry) => {
          if (chosen.length < 3) {
            addUnique(entry, 'Strong alternative');
          }
        });

        return chosen.slice(0, 3);
      };

      const showNoResults = () => {
        if (!resultGrid) return;

        resultGrid.innerHTML = `
          <div class="mg-gfp__no-results">
            <h3>No products are currently available in that exact budget range.</h3>
            <p>Please start again and choose a different budget, or browse all best sellers.</p>
          </div>
        `;
      };

      const showResults = () => {
        if (!resultGrid) return;

        resultGrid.innerHTML = '';
        const recommendations = chooseRecommendations();

        if (recommendations.length === 0) {
          showNoResults();
        } else {
          recommendations.forEach(({ entry, label }) => {
            const clone = entry.card.cloneNode(true);
            clone.hidden = false;

            const resultLabel = clone.querySelector('[data-result-label]');
            const reason = clone.querySelector('[data-reason]');

            if (resultLabel) resultLabel.textContent = label;
            if (reason) reason.textContent = buildReason(entry.card);

            resultGrid.appendChild(clone);
          });
        }

        if (corporateResult) {
          corporateResult.hidden = !(
            answers.occasion === 'corporate' ||
            answers.recipient === 'client'
          );
        }

        const query = new URLSearchParams(window.location.search);

        Object.entries(answers).forEach(([key, value]) => {
          query.set(key, value);
        });

        query.set('show', 'results');

        window.history.replaceState(
          {},
          '',
          `${window.location.pathname}?${query.toString()}`
        );

        if (finderPanel) finderPanel.hidden = true;

        if (results) {
          results.hidden = false;
          results.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      };

      const advanceAfterSelection = () => {
        if (advanceTimer) {
          window.clearTimeout(advanceTimer);
        }

        isAdvancing = true;

        advanceTimer = window.setTimeout(() => {
          const isFinalStep = currentStep === steps.length - 1;

          if (isFinalStep) {
            showResults();
          } else {
            showStep(currentStep + 1);
          }

          isAdvancing = false;
          advanceTimer = null;
        }, 180);
      };

      root.addEventListener('click', (event) => {
        const option = event.target.closest('[data-answer]');

        if (option && root.contains(option)) {
          if (isAdvancing) return;

          const step = option.closest('[data-step]');
          const stepIndex = steps.indexOf(step);

          if (stepIndex !== currentStep) return;

          setSelected(step, option.dataset.answer);
          advanceAfterSelection();
          return;
        }

        if (event.target.closest('[data-next]')) {
          if (!nextButton || nextButton.disabled || isAdvancing) return;

          if (currentStep === steps.length - 1) {
            showResults();
          } else {
            showStep(currentStep + 1);
          }
          return;
        }

        if (event.target.closest('[data-back]')) {
          if (advanceTimer) {
            window.clearTimeout(advanceTimer);
            advanceTimer = null;
          }

          isAdvancing = false;
          showStep(currentStep - 1);
          return;
        }

        if (event.target.closest('[data-restart]')) {
          if (advanceTimer) {
            window.clearTimeout(advanceTimer);
            advanceTimer = null;
          }

          isAdvancing = false;

          Object.keys(answers).forEach((key) => delete answers[key]);

          root.querySelectorAll('[data-answer]').forEach((button) => {
            button.setAttribute('aria-pressed', 'false');
          });

          if (resultGrid) resultGrid.innerHTML = '';
          if (results) results.hidden = true;
          if (finderPanel) finderPanel.hidden = false;

          const cleanQuery = new URLSearchParams(window.location.search);

          ['recipient', 'occasion', 'knowledge', 'preference', 'budget', 'show']
            .forEach((key) => cleanQuery.delete(key));

          const cleanUrl = cleanQuery.toString()
            ? `${window.location.pathname}?${cleanQuery.toString()}`
            : window.location.pathname;

          window.history.replaceState({}, '', cleanUrl);
          showStep(0);

          finderPanel?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });

      const query = new URLSearchParams(window.location.search);

      ['recipient', 'occasion', 'knowledge', 'preference', 'budget'].forEach(
        (group) => {
          const value = query.get(group);
          if (!value) return;

          const step = root.querySelector(`[data-group="${group}"]`);
          let option = null;

          if (
            step &&
            window.CSS &&
            typeof CSS.escape === 'function'
          ) {
            option = step.querySelector(
              `[data-answer="${CSS.escape(value)}"]`
            );
          } else if (step) {
            option = Array.from(step.querySelectorAll('[data-answer]')).find(
              (candidate) => candidate.dataset.answer === value
            );
          }

          if (step && option) {
            setSelected(step, value);
          }
        }
      );

      const allPrefilled = [
        'recipient',
        'occasion',
        'knowledge',
        'preference',
        'budget'
      ].every((key) => answers[key]);

      if (query.get('show') === 'results' && allPrefilled) {
        showResults();
      } else {
        showStep(0);
      }
    };

    const initialiseAll = (scope = document) => {
      if (scope.matches?.(SELECTOR)) initialise(scope);
      scope.querySelectorAll(SELECTOR).forEach(initialise);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll());
    } else {
      initialiseAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initialiseAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s_timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("s-timeline__img--bounce-in"),t.contents[e].classList.add("s-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-s-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
